module.exports = __webpack_public_path__ + "img/guangao03.29232ee0.png";